module.exports = __webpack_public_path__ + "img/airplane.d0c68794.png";